import useLux from '../composables/useLux';

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const { isEnabled } = useLux();

  router.beforeEach((_, __, next) => {
    if (window.LUX && isEnabled) {
      window.LUX?.startSoftNavigation?.();
    }

    next();
  });

  nuxtApp.hook('page:finish', () => {
    if (window.LUX && isEnabled) {
      window.LUX?.markLoadTime?.();
    }
  });
});
